export const MODULE_NAME = 'cart';

export const REGEX_GREEN_CONFIG = /\*{2}(.*?)\*{2}/;
